import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DistribucionAnexo21y22RMF2026SGM() {
  return (
    <CategoryPage
      category="distribucionAnexo21Y22Rmf2026SGM2026"
      pageTitle="SGM 2026"
    />
  );
}

export default DistribucionAnexo21y22RMF2026SGM;
